
<template>
	<div id="dashboard-doctor">
		<div class="container">
			<div class="field px-3">
				<div class="control has-icons-right">
					<input
						class="input is-medium"
						type="text"
						placeholder="Buscar Paciente"
						v-model="searchTerm"
						@input="filterWhileTyping"
					/>
					<span class="icon is-small is-right">
						<i class="fas fa-search"></i>
					</span>
				</div>
			</div>
			<!-- <div>
				<button @click="testSendMessage">SendMessage</button>
			</div> -->
			<div class="header-results">
				<div>Nombres</div>
				<div>Fecha y hora de ult. medición</div>
				<div class="sensor-label">Frec. Resp.</div>
				<div class="sensor-label">Sat O2</div>
				<div class="sensor-label">Frec. Card.</div>
				<div class="sensor-label">Temp.</div>
			</div>
			<div v-if="patients === null">
				<inline-loading-indicator></inline-loading-indicator>
			</div>
			<div
				v-else-if="
					results === null ? patients.length === 0 : results.length === 0
				"
			>
				No se encontró pacientes
			</div>
			<div v-else class="results-container px-3">
				<patient-card
					class="my-4"
					v-for="(patient, i) in results === null ? patients : results"
					:key="'patient-' + i"
					:patient="patient"
					@click="onClickPatient(patient)"
				></patient-card>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent, onMounted, ref } from "vue";
	import useDoctor from "@/store/DoctorState";
	import PatientCard from "@/components/PatientCard.vue";
	import InlineLoadingIndicator from "@/components/InlineLoadingIndicator.vue";
	import { Patient } from "@/domain/entities/Patient";
	import { useRouter } from "vue-router";

	export default defineComponent({
		name: "dashboard-doctor",
		components: {
			PatientCard, InlineLoadingIndicator
		},
		setup() {
			const router = useRouter();
			const { patients, loadPatients, selectPatient } = useDoctor();
			onMounted(async () => {
				await loadPatients();
			});
			function onClickPatient(patient: Patient) {
				selectPatient(patient);
				router.push("/patient");
			}

			let searchTerm = ref<string>("");
			let results = ref<Patient[] | null>(null);

			function filterWhileTyping() {
				if (patients === null) return;
				if (searchTerm.value.length < 4) {
					results.value = patients.value!;
					return;
				}

				let result = patients.value!.filter(
					(p) =>
						p.firstName.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
						p.lastName.toLowerCase().includes(searchTerm.value.toLowerCase())
				);
				results.value = result;
			}
			return { patients, results, onClickPatient, searchTerm, filterWhileTyping };
		},
	});
</script>

<style lang="stylus" scoped>
@import '../styles/layout.styl';
	.header-results {
		display: grid;
		grid-template-columns: widthFixedColumn widthFixedColumn auto auto auto auto;

		@media screen and (max-width: 500px) {
			display: none;
		}
	}


	.header-results >div {
		font-weight: bold;
	}
</style>